import React from 'react';
import DecipherIcon from '../../../assets/images/decipher.png';
import IntervuIcon from '../../../assets/images/intervu.png';
import RevelationIcon from '../../../assets/images/revelation.png';
import LiveVideoIcon from '../../../assets/images/livevideo.png';

const ProjectHeader = ({ title, projectType }) => {

  const iconPath =
    projectType === 0 ? IntervuIcon
      : projectType === 1 ? DecipherIcon
        : projectType === 2 ? RevelationIcon
          : projectType === 3 ? LiveVideoIcon
            : null;

  return (
    <header className="section-header">
      <h1>
        {(iconPath && <img src={iconPath} width="44" height="44" alt={title} />)}
        {title}
      </h1>
    </header>
  );
}

export default ProjectHeader;



// WEBPACK FOOTER //
// ./src/components/projects/ProjectForm/ProjectHeader.js